import React from 'react';
import { numberFormat } from '../../../config/numberFormat';

// Paid + Unpaid = Total cards of the Sale and Sale Return lists. In the combined
// view credit notes are netted off, so when refunds exceed collections Paid is
// negative. That case reads Unpaid - Net Refund = Total, which keeps the sum
// correct without showing a negative Paid.
const SaleTotalsCards = ({ paid, unpaid, total }) => {
    const paidAmount = parseFloat(paid) || 0;
    const isNetRefund = paidAmount <= -0.005;

    const card = (id, label, amount) => (
        <div className="blockAreaList" style={{width : '250Px !important'}}>
            <div className="py-10 text-left" id={id}>
                <div className="text-muted">{label}</div>
                <div className="font-size-h5 font-w600">{numberFormat(amount)}</div>
            </div>
        </div>
    );
    const unpaidCard = card('unpaidArea', 'Unpaid', unpaid);

    return (
        <div className="col-lg-12">
            {isNetRefund ? unpaidCard : card('paidArea', 'Paid', Math.abs(paidAmount) < 0.005 ? 0 : paidAmount)}
            <div className="blockAreaListIcon"><i className={isNetRefund ? 'fa fa-minus' : 'fa fa-plus'}></i></div>
            {isNetRefund ? card('paidArea', 'Net Refund', Math.abs(paidAmount)) : unpaidCard}
            <div className="blockAreaListIcon"><i className="fas fa-equals"></i></div>
            {card('totalArea', 'Total', total)}
        </div>
    );
};

export default SaleTotalsCards;
